<!--
  - Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
  - #  This file forms part of the Trade-DSM application frontend.
  - #  https://github.com/Tooblippe/trade-dsm-frontend
  -->
<template>
  <v-main bg fluid>
    <v-container>
      <v-row justify="center">
        <v-col>
          <h1>Trade Data App - {{ $store.state.app.selected_application }}</h1>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
export default {
  name: 'trade-erp-app',
  components: {}, //
  data() {
    return {
      dialog: true,
    };
  },
};
</script>

<style scoped></style>
